import { Component, OnInit, Input, EventEmitter, Output } from "@angular/core";
import { ToasterService } from 'angular5-toaster';
import { UserComment, ModerationStatus } from "../../core/review";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { TramApiService } from "../../tram-api.service";
import { ReviewService } from "../../providers/review.service";
import { HttpErrorResponse } from "@angular/common/http";

@Component({
    selector: 'comment-form',
    templateUrl: './comment-form.component.html',
    styleUrls: ['./style.scss', './comment-form.component.scss']
})
export class CommentFormComponent implements OnInit {
    @Input() userComment: UserComment;
    @Input() isOpened: boolean;

    @Output() closed = new EventEmitter<boolean>();

    commentForm: FormGroup;
    isLoading: boolean;

    constructor(private reviewService: ReviewService,
        private formBuilder: FormBuilder,
        private toaster: ToasterService) { }

    ngOnInit() {
        this.commentForm = this.formBuilder.group({
            comment: [null, Validators.required]
        });
    }

    onSubmit() {
        const comment = this.commentForm.value.comment;
        const review = this.userComment.parentReview;
        this.isLoading = true;

        this.reviewService.createComment(review, comment)
            .then(pack => {
                this.isLoading = false;
                this.toaster.pop('success', null, 'Комментарий отправлен на модерацию');
                this.close();
            })
            .catch(error => this.handleError(error));
    }

    close() {
        this.commentForm.reset();
        this.isOpened = false;
        this.closed.emit(this.isOpened);
    }

    private handleError(error: HttpErrorResponse | string) {
        this.isLoading = false;
        if (error instanceof HttpErrorResponse) {
            this.toaster.pop('error', null, error.statusText);
        } else {
            this.toaster.pop('error', null, error);
        }
    }
}


// WEBPACK FOOTER //
// D:/programming/Чижик_Api_Site_Sources-Electroline/front/src/app/common/review/comment-form.component.ts